import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/utils/classes";

/* Variants */
const variants = cva("card bg-base-100 border-2 border-base-300 rounded-2xl", {
  variants: {
    size: {
      small: "w-auto max-w-60 rounded-lg",
      large: "min-w-72 max-w-60",
      auto: "w-auto",
    },
  },
  defaultVariants: {
    size: "large",
  },
});

/* Prop Types */
interface CardSkeletonProps extends VariantProps<typeof variants> {
  className?: string;
  loadTitle?: boolean;
  loadBody?: boolean;
}

/*
 * Card Skeleton Component
 */
export const CardSkeleton = ({ size, className, loadTitle = true, loadBody = true }: CardSkeletonProps) => {
  return (
    <div className={cn(variants({ size }), className)}>
      {/* Skeleton Image */}
      <div className={cn("skeleton min-h-28 max-h-[184px] h-[184px] w-full rounded-2xl", { "max-h-28 rounded-t-lg": size === "small" })} />

      {/* Skeleton Content */}
      <div className={`${!loadTitle && !loadBody ? "" : "px-6 py-7 space-y-3"}`}>
        {loadTitle && <div className="skeleton h-7 w-full rounded-lg" />}
        {loadBody && <div className="skeleton h-7 w-full rounded-lg" />}
      </div>
    </div>
  );
};
